import { useState } from 'react';
import { Breadcrumb } from 'types';
import { initialBreadcrumbs } from './breadcrumbs-ctx';

export function useBreadcrumbs() {
  /**
   *
   */
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>(
    initialBreadcrumbs.breadcrumbs
  );

  return {
    breadcrumbs,
    setBreadcrumbs,
  };
}
